import { computed, ref } from '@vue/composition-api';
export var SortDir;
(function (SortDir) {
    SortDir["ASC"] = "asc";
    SortDir["DESC"] = "desc";
})(SortDir || (SortDir = {}));
var SortSign;
(function (SortSign) {
    SortSign["ASC"] = "+";
    SortSign["DESC"] = "-";
})(SortSign || (SortSign = {}));
const SORT_DIR_TO_SIGN_MAP = {
    [SortDir.ASC]: SortSign.ASC,
    [SortDir.DESC]: SortSign.DESC,
};
const SORT_SIGN_TO_DIR_MAP = {
    [SortSign.ASC]: SortDir.ASC,
    [SortSign.DESC]: SortDir.DESC,
};
export const useSort = (fieldMapping) => {
    const sortConfig = ref(null);
    const sort = (field) => {
        if (sortConfig.value === null || sortConfig.value?.field !== field) {
            sortConfig.value = {
                field,
                dir: SortDir.ASC,
            };
            return;
        }
        if (sortConfig.value.dir === SortDir.ASC) {
            sortConfig.value = { ...sortConfig.value, dir: SortDir.DESC };
        }
        else {
            sortConfig.value = null;
        }
    };
    const sortBy = computed(() => {
        if (!sortConfig.value)
            return;
        const { dir, field } = sortConfig.value;
        const mappedField = fieldMapping?.[field] ?? field;
        const sign = dir ? SORT_DIR_TO_SIGN_MAP[dir] : '';
        return `${sign}${mappedField}`;
    });
    const setSortBy = (sortBy) => {
        const dir = SORT_SIGN_TO_DIR_MAP[sortBy.charAt(0)];
        if (!dir)
            return;
        const field = sortBy.slice(1);
        let originalField = field;
        if (fieldMapping) {
            const reversedMapping = Object.entries(fieldMapping).find(([_, value]) => value === field);
            if (reversedMapping) {
                originalField = reversedMapping[0];
            }
        }
        sortConfig.value = {
            field: originalField,
            dir,
        };
    };
    return {
        sortConfig,
        sortBy,
        setSortBy,
        sort,
    };
};
